"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Card_styles_1 = require("./Card.styles");
var PriceBreakDown_1 = __importDefault(require("./PriceBreakDown"));
var formatAndDropDecimal_1 = __importDefault(require("../../../utils/formatAndDropDecimal"));
var roundApr_1 = __importDefault(require("../../../utils/roundApr"));
var TileDataContext_1 = require("../../TileDataContext");
var AuthPayMonthly = function () {
    var _a = (0, TileDataContext_1.useTileDataContext)(), _b = _a.tileData, vehicleId = _b.vehicleId, transportCost = _b.transportCost, _c = _b.price, total = _c.total, totalDiscountAmount = _c.totalDiscountAmount, _d = _a.financeInfo, price = _d.price, tradeInApplied = _d.tradeInApplied;
    var _e = price !== null && price !== void 0 ? price : {}, _f = _e.apr, apr = _f === void 0 ? 0 : _f, _g = _e.monthlyPayment, monthlyPayment = _g === void 0 ? 0 : _g, _h = _e.termInMonths, termInMonths = _h === void 0 ? 0 : _h, downPaymentDetails = _e.downPaymentDetails, _j = _e.feesMinusShipping, feesMinusShipping = _j === void 0 ? 0 : _j, estimatedTaxesAndFees = _e.estimatedTaxesAndFees, _k = _e.totalTaxes, totalTaxes = _k === void 0 ? 0 : _k;
    var fees = estimatedTaxesAndFees !== null && estimatedTaxesAndFees !== void 0 ? estimatedTaxesAndFees : feesMinusShipping + totalTaxes;
    var _l = downPaymentDetails !== null && downPaymentDetails !== void 0 ? downPaymentDetails : {}, _m = _l.nonRefundableShippingFees, nonRefundableShippingFees = _m === void 0 ? 0 : _m, _o = _l.totalCashDue, totalCashDue = _o === void 0 ? 0 : _o, _p = _l.additionalCashDown, additionalCashDown = _p === void 0 ? 0 : _p, _q = _l.tradeDown, tradeDown = _q === void 0 ? 0 : _q;
    var tradeValue = tradeInApplied ? tradeDown : 0;
    var showNSFVerbiage = transportCost !== 0 && transportCost === nonRefundableShippingFees;
    var totalPurchasePrice = total + transportCost + fees - tradeValue;
    var totalAmountFinanced = totalPurchasePrice - totalCashDue;
    var failedToFetchTerms = monthlyPayment === 0;
    var handleFallbackCtaClick = function () {
        // trackEvent('Clicked View VDP from Price Details Fallback', {
        //   vehicleId
        // });
    };
    return (react_1.default.createElement(Card_styles_1.Card, null,
        failedToFetchTerms ? (react_1.default.createElement("div", { className: "text-xs" },
            react_1.default.createElement("p", { className: "text-grey-5" }, "We\u2019re having trouble loading terms for this vehicle."),
            react_1.default.createElement("a", { href: "/vehicle/".concat(vehicleId), "data-analytics-id": null, onClick: function () { return handleFallbackCtaClick(); } }, "View the vehicle details page to see your terms."))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Card_styles_1.AuthTitleWrapper, null,
                react_1.default.createElement(Card_styles_1.Title, null, "Pay Monthly"),
                react_1.default.createElement(Card_styles_1.Price, null,
                    "$",
                    (0, formatAndDropDecimal_1.default)(monthlyPayment),
                    react_1.default.createElement("span", { className: "t-body-m" }, "/mo")),
                react_1.default.createElement(Card_styles_1.DisclaimerText, null,
                    "Includes ",
                    (0, roundApr_1.default)(apr),
                    "% APR for ",
                    termInMonths,
                    " months and a $10/mo autopay discount")),
            react_1.default.createElement(Card_styles_1.AuthTitleWrapper, null,
                react_1.default.createElement(Card_styles_1.Title, null, "Total due at order"),
                react_1.default.createElement(Card_styles_1.Price, null,
                    "$",
                    (0, formatAndDropDecimal_1.default)(totalCashDue))),
            react_1.default.createElement(Card_styles_1.GreyBar, null))),
        react_1.default.createElement(PriceBreakDown_1.default, { appliedTrade: tradeInApplied, showNSFVerbiage: showNSFVerbiage, taxTitleReg: fees, total: total, totalDiscount: totalDiscountAmount, transportCost: transportCost, tradeDown: tradeValue, card: "monthly" }),
        react_1.default.createElement(Card_styles_1.GreyBar, null),
        react_1.default.createElement(Card_styles_1.LineItem, null,
            react_1.default.createElement(Card_styles_1.Title, null, "Total Purchase Price"),
            react_1.default.createElement(Card_styles_1.Title, null,
                "$",
                (0, formatAndDropDecimal_1.default)(totalPurchasePrice))),
        react_1.default.createElement(Card_styles_1.GreyListSection, null,
            react_1.default.createElement(Card_styles_1.LineItem, null,
                react_1.default.createElement(Card_styles_1.DisclaimerText, null,
                    showNSFVerbiage ? 'Nonrefundable s' : 'S',
                    "hipping fee"),
                react_1.default.createElement(Card_styles_1.DisclaimerText, null,
                    "$",
                    (0, formatAndDropDecimal_1.default)(transportCost))),
            react_1.default.createElement(Card_styles_1.LineItem, null,
                react_1.default.createElement(Card_styles_1.DisclaimerText, null, "Cash down payment"),
                react_1.default.createElement(Card_styles_1.DisclaimerText, null,
                    "$",
                    (0, formatAndDropDecimal_1.default)(additionalCashDown))),
            react_1.default.createElement(Card_styles_1.GreyBarSpace, null),
            react_1.default.createElement(Card_styles_1.LineItem, null,
                react_1.default.createElement(Card_styles_1.Title, null, "Total Due at Order "),
                react_1.default.createElement(Card_styles_1.Title, null,
                    "$",
                    (0, formatAndDropDecimal_1.default)(totalCashDue)))),
        react_1.default.createElement(Card_styles_1.GreyListSection, null,
            react_1.default.createElement(Card_styles_1.LineItem, null,
                react_1.default.createElement(Card_styles_1.Title, null, "Total Amount Financed "),
                react_1.default.createElement(Card_styles_1.Title, null,
                    "$",
                    (0, formatAndDropDecimal_1.default)(totalAmountFinanced))))));
};
exports.default = AuthPayMonthly;
//# sourceMappingURL=AuthPayMonthly.js.map